<div *ngIf="loading else verificationForm"
	 class="text-center" style="margin: 0 auto">
	<app-kamona-loading [parentHeight]="'415'" loadingText="Loading OTP...">
	</app-kamona-loading>
</div>
<ng-template #verificationForm>
	<div class="phone-verification">
		<div class="phone-verification-step">
			<app-kamona-layout [minHeight]="'calc(100vh - 250px)'">
				<div content>
					<div class="custom-mobile-content">
						<div>
							<app-password-input-box (emitInput)="setPin($event)">
							</app-password-input-box>
						</div>
						<div class="m-t-7">
							<div nz-row nzJustify="end">
								<div>
									<app-otp-count-down (emitRetryAction)="retryOtp()"
														[countdownType]="countdownType"
														[errorMessage]="otpErrorMessage">
									</app-otp-count-down>
								</div>
							</div>
						</div>
						<div class="m-t-24">
							<app-ussd-board (click)="callDialer(ussdCode)" [ussdCode]="ussdCode"></app-ussd-board>
						</div>
					</div>
				</div>
				<div footer>
					<div [nzGutter]="15"
						 nz-row nzAlign="middle"
						 nzJustify="space-between">
						<div nz-col nzSpan="12">
							<div>
								<div (click)="goBack()" [ngClass]="{'gray-out':submitting}"
									 class="plain-back-button">
									Back
								</div>
							</div>
						</div>
						<div nz-col nzSpan="12">
							<div [ngClass]="{'gray-out':submitting}" class="kamona-button-session">
								<app-kamona-custom-button (submitForm)="next()"
														  [isBlock]="true"
														  [isDisabled]="!isDisable"
														  [isSubmitting]="submitting"
														  [state]="'primary'"
														  text="Next">
								</app-kamona-custom-button>
							</div>
						</div>
					</div>
				</div>
			</app-kamona-layout>
		</div>
	</div>
</ng-template>
